<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    membership: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      form: {
        name: this.membership?.name || '',
        description: this.membership?.description || '',
      },
    };
  },
  computed: {
    ...mapGetters({
      hasPercentPlan: 'auth/hasPercentPlan',
    }),
    isEditing() {
      return !!this.membership;
    },
    modalTitle() {
      return this.isEditing ? 'Modifier le plan' : 'Créer un plan d\'abonnement';
    },
    submitButtonText() {
      return this.isEditing ? 'Modifier' : 'Créer';
    },
  },
  methods: {
    async handle() {
      if (this.hasPercentPlan) {
        this.$showMessage.goPro();
        return;
      }

      this.isLoading = true;

      try {
        let response;
        if (this.isEditing) {
          response = await this.$store.dispatch('memberships/update', {
            uuid: this.membership.uuid,
            membershipData: this.form,
          });
        } else {
          response = await this.$store.dispatch('memberships/create', this.form);
        }

        this.$showMessage.success(
          this.isEditing ? 'Plan modifié avec succès' : 'Plan créé avec succès',
        );

        this.$emit('close');

        // Redirect to content management for new memberships
        if (!this.isEditing && response) {
          this.$router.push({
            name: 'membership_items',
            params: { uuid: response.uuid },
          });
        }
      } catch (error) {
        this.$showMessage.error(
          this.isEditing ? 'Erreur lors de la modification' : 'Erreur lors de la création',
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<template>
  <form class="modal-card" style="width: 600px" @submit.prevent="dataIsValid(isLoading) && handle()">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ modalTitle }}</p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>

    <section class="modal-card-body">
      <div class="columns is-multiline">
        <div class="column is-12 pb-0">
          <BaseField
            v-model="form.name"
            :field="{
              label: 'Nom du plan *',
              type: 'text',
              inputAttrs: {
                required: true,
                maxlength: 255,
                placeholder: 'Ex: Plan Pro, Plan Expert...',
              },
            }"
            autofocus />
        </div>

        <div class="column is-12 pt-0">
          <BaseField
            v-model="form.description"
            :field="{
              label: 'Description',
              type: 'textarea',
              inputAttrs: {
                maxlength: 200,
                placeholder: 'Décrivez brièvement ce que ce plan offre...',
                rows: 3,
              },
            }" />
        </div>

        <div class="column is-12">
          <div class="notification is-info is-light">
            <strong>💡 Conseil :</strong> Après création, vous pourrez configurer le prix, la fréquence et ajouter du contenu à votre plan d'abonnement.
          </div>
        </div>
      </div>
    </section>

    <footer class="modal-card-foot is-justify-content-flex-end">
      <div class="buttons">
        <b-button type="is-text" @click="$emit('close')">
          Annuler
        </b-button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="isLoading">
          {{ submitButtonText }}
        </b-button>
      </div>
    </footer>
  </form>
</template>
